/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyContestParagraph = {

	deleteParagraph (context, contestId, paragraphId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-contest-paragraph/paragraph"
			+ "?contestId=" + contestId
			+ "&paragraphId=" + paragraphId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllParagraphs (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest-paragraph/all-paragraphs"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putParagraph (context, contestId, name, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest-paragraph/paragraph"
			+ "?contestId=" + contestId
			+ "&name=" + name
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
